"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _clsx = _interopRequireDefault(require("clsx"));
var _lottieHotspotAnimation = _interopRequireDefault(require("../styles/lottie-hotspot-animation.css"));
var _dotlottieWeb = require("@lottiefiles/dotlottie-web");
var _text = require("@mmc/text");
var _hotspot = _interopRequireDefault(require("./hotspot.json"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var LottieHotspotAnimation = function LottieHotspotAnimation(_ref) {
  var className = _ref.className,
    market = _ref.market,
    language = _ref.language,
    data = _ref.data;
  var _useState = (0, _react.useState)(window.innerWidth),
    windowWidth = _useState[0],
    setWindowWidth = _useState[1];
  var _useState2 = (0, _react.useState)({}),
    deviceSpecificStyles = _useState2[0],
    setDeviceSpecificStyles = _useState2[1];
  var hotspotTriggerClass = "hotspot--" + (data && data.hotspotClass);
  (0, _react.useEffect)(function () {
    if (data && data.hotspotClass) {
      var dotLottie = new _dotlottieWeb.DotLottie({
        autoplay: true,
        loop: true,
        canvas: document.querySelector("#" + data.hotspotClass),
        data: _hotspot["default"]
      });
      dotLottie.setLayout(_objectSpread(_objectSpread({}, dotLottie.layout), {}, {
        fit: 'fill'
      }));
    }
    var handleWindowResize = function handleWindowResize() {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleWindowResize);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (data && data.desktopAlignment && data.mobileAlignment) {
      setDeviceSpecificStyles(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          requiredAnimationStyles: windowWidth > 768 ? data.desktopAlignment : data.mobileAlignment,
          requiredLayoutStyles: windowWidth > 768 ? 'desktopLayout' : 'mobileLayout',
          requiredPositionStyles: windowWidth > 768 ? 'lottieHotspotCtaBoxPositionDesktop' : 'lottieHotspotCtaBoxPositionMobile'
        });
      });
    }
  }, [windowWidth]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_lottieHotspotAnimation["default"].lottieHotspotAnimation, _lottieHotspotAnimation["default"][deviceSpecificStyles.requiredAnimationStyles])
  }, data && data.hotspotClass && /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _lottieHotspotAnimation["default"].lottieHotspotBox,
    style: {
      zIndex: data.zIndex
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hotspot " + hotspotTriggerClass + " " + _lottieHotspotAnimation["default"].lottieHotspotTiggerClass,
    style: {
      zIndex: data.zIndex
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_lottieHotspotAnimation["default"].canvas, _lottieHotspotAnimation["default"][deviceSpecificStyles.requiredAnimationStyles], _lottieHotspotAnimation["default"][deviceSpecificStyles.requiredLayoutStyles])
  }, data && data.hotspotClass && /*#__PURE__*/_react["default"].createElement("canvas", {
    id: data.hotspotClass,
    className: "" + _lottieHotspotAnimation["default"].canvasBox
  }), data && data.hotspotClass && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_lottieHotspotAnimation["default"].lottieHotspotCtaBox, _lottieHotspotAnimation["default"].lottieHotspotCtaBoxPosition, _lottieHotspotAnimation["default"][deviceSpecificStyles.requiredPositionStyles])
  }, data && data.labelText && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: _lottieHotspotAnimation["default"].ctaText,
    text: data.labelText,
    tag: "p"
  })))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
LottieHotspotAnimation.resourceType = function () {
  return 'LottieHotspotAnimation_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(LottieHotspotAnimation);
exports["default"] = _default;